(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  // "$ {{amount}}" -> "$ 1,234" (sin centavos cuando son .00, igual que en Liquid)
  function money(cents) {
    const value = cents / 100;
    const text = value.toLocaleString('en-US', {
      minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
      maximumFractionDigits: 2,
    });
    return (window.theme?.moneyFormat || '$ {{amount}}').replace(/\{\{\s*\w+\s*\}\}/, text).replace(/<[^>]+>/g, '');
  }

  /*
    Diálogos (aviso de edad y menú móvil): mientras uno está abierto, el resto de la
    página queda inerte y sin scroll, y Tab da la vuelta dentro del diálogo.
  */
  const FOCUSABLE = 'a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])';
  function lockPage(dialog) {
    const outside = [...document.body.children].filter(
      (el) => !el.contains(dialog) && !['SCRIPT', 'NOSCRIPT', 'STYLE'].includes(el.tagName) && !el.inert,
    );
    outside.forEach((el) => (el.inert = true));
    document.documentElement.classList.add('is-locked');

    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      const items = $$(FOCUSABLE, dialog).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', onKey);

    return () => {
      outside.forEach((el) => (el.inert = false));
      document.documentElement.classList.remove('is-locked');
      document.removeEventListener('keydown', onKey);
    };
  }

  /* Aviso de edad */
  const gate = $('[data-gate]');
  if (gate) {
    let unlockGate = null;
    const KEY = 'mc-mayor-de-edad';
    const read = () => {
      try {
        return localStorage.getItem(KEY);
      } catch {
        return null;
      }
    };
    const save = (value) => {
      try {
        localStorage.setItem(KEY, value);
      } catch {
        // Sin almacenamiento el aviso vuelve a salir en la siguiente visita.
      }
    };
    const deny = () => {
      $('[data-gate-ask]', gate).hidden = true;
      $('[data-gate-denied]', gate).hidden = false;
    };
    const state = read();
    if (state !== 'si') {
      gate.hidden = false;
      unlockGate = lockPage(gate);
      if (state === 'no') deny();
      else $('[data-gate-yes]', gate).focus();
    }
    $('[data-gate-yes]', gate).addEventListener('click', () => {
      save('si');
      gate.hidden = true;
      unlockGate?.();
    });
    $('[data-gate-no]', gate).addEventListener('click', () => {
      save('no');
      deny();
    });
  }

  /* Menú móvil */
  const drawer = $('[data-drawer]');
  const opener = $('[data-drawer-open]');
  if (drawer && opener) {
    const panel = $('.drawer__panel', drawer);
    let unlockDrawer = null;
    const toggle = (open) => {
      drawer.classList.toggle('is-open', open);
      opener.setAttribute('aria-expanded', String(open));
      unlockDrawer?.();
      unlockDrawer = open ? lockPage(panel) : null;
      if (open) $('button', panel).focus();
      else opener.focus();
    };
    opener.addEventListener('click', () => toggle(true));
    $$('[data-drawer-close]', drawer).forEach((el) => el.addEventListener('click', () => toggle(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) toggle(false);
    });
  }

  /* Pestañas del home */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    tabs.forEach((tab) =>
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
        });
        // El carrusel de la pestaña recién visible recalcula sus flechas.
        dispatchEvent(new Event('resize'));
      }),
    );
  });

  /* Catálogo: existencia y orden */
  const catalog = $('[data-catalog]');
  const grid = catalog && $('[data-catalog-grid]', catalog);
  if (grid) {
    const cards = $$('[data-card]', grid);
    const stock = $('[data-catalog-stock]', catalog);
    const sort = $('[data-catalog-sort]', catalog);
    const count = $('[data-catalog-count]', catalog);
    const empty = $('[data-catalog-empty]', catalog);
    const num = (card, key) => Number(card.dataset[key]);
    const orders = {
      nuevo: (a, b) => num(b, 'date') - num(a, 'date'),
      menor: (a, b) => num(a, 'price') - num(b, 'price'),
      mayor: (a, b) => num(b, 'price') - num(a, 'price'),
      mayoreo: (a, b) => num(a, 'low') - num(b, 'low'),
    };
    const apply = () => {
      const available = (card) => card.dataset.available === 'true';
      // Los agotados siempre al final, sin importar el orden elegido.
      [...cards]
        .sort((a, b) => Number(available(b)) - Number(available(a)) || orders[sort.value](a, b))
        .forEach((card) => grid.appendChild(card));
      let shown = 0;
      cards.forEach((card) => {
        card.hidden = stock.checked && !available(card);
        if (!card.hidden) shown += 1;
      });
      count.textContent = shown;
      if (empty) empty.hidden = shown > 0;
    };
    stock.addEventListener('change', apply);
    sort.addEventListener('change', apply);
    apply();
  }


  const html = document.documentElement;
  const pieces = (n) => `${n} ${n === 1 ? 'pieza' : 'piezas'}`;
  const esc = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const sized = (src, width) => {
    if (!src) return '';
    try {
      const url = new URL(src, location.origin);
      url.searchParams.set('width', width);
      return url.href;
    } catch {
      return src;
    }
  };

  // Miniatura de un producto del carrito; las fotos con fondo blanco liso llevan el filtro que lo quita.
  const thumb = (src, handle, width) =>
    src
      ? `<img src="${esc(sized(src, width))}" alt="" width="${width / 2}" height="${width / 2}" loading="lazy"${(window.theme?.knockout || []).includes(handle) ? ' class="img-knockout"' : ''}>`
      : '';

  /* Menú Marcas en computadora: abre con el cursor, con Enter o con flecha abajo; cierra con Esc */
  $$('[data-mega]').forEach((item) => {
    const link = $('[data-mega-link]', item);
    const panel = $('[data-mega-panel]', item);
    let timer = null;
    const isOpen = () => !panel.hidden;
    const set = (open) => {
      clearTimeout(timer);
      panel.hidden = !open;
      link.setAttribute('aria-expanded', String(open));
    };
    item.addEventListener('mouseenter', () => set(true));
    item.addEventListener('mouseleave', () => {
      timer = setTimeout(() => set(false), 150);
    });
    link.addEventListener('keydown', (e) => {
      // Primer Enter abre el panel; con el panel abierto, Enter sigue el enlace a la página Marcas.
      if ((e.key === 'Enter' && !isOpen()) || e.key === 'ArrowDown') {
        e.preventDefault();
        set(true);
        if (e.key === 'ArrowDown') $('a', panel)?.focus();
      }
    });
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) {
        set(false);
        link.focus();
      }
    });
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) set(false);
    });
  });

  /* Contador del carrito: siempre con el dato real de /cart.js */
  const setCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };
  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  /*
    Aviso al agregar al carrito. Un solo panel: si llega otra alta con el panel abierto,
    se actualiza en lugar de apilar otro. Se cierra a los 8 s salvo que el cursor o el
    foco estén dentro; también con la X, con Esc y con "Seguir comprando".
  */
  const added = $('[data-added]');
  const addedNotice = (() => {
    if (!added) return { show() {}, error() {} };
    const body = $('[data-added-body]', added);
    const title = $('[data-added-title]', added);
    const actions = $('[data-added-actions]', added);
    const live = $('[data-added-live]');
    let timer = null;
    let hold = false;

    const place = () => {
      // Sobre la barra de compra fija (si está pegada abajo) y moviendo el botón de WhatsApp encima.
      let offset = 0;
      const bar = $$('.buybar').find((el) => el.offsetParent !== null && !el.closest('dialog'));
      if (bar) {
        const rect = bar.getBoundingClientRect();
        if (rect.bottom >= innerHeight - 2 && rect.top < innerHeight) offset = innerHeight - rect.top;
      }
      added.style.setProperty('--added-offset', `${offset}px`);
      html.style.setProperty('--added-h', `${added.offsetHeight + offset}px`);
    };
    const close = () => {
      clearTimeout(timer);
      added.hidden = true;
      html.classList.remove('has-added');
    };
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!hold) close();
      }, 8000);
    };
    const open = (heading, content, ok) => {
      title.textContent = heading;
      body.innerHTML = content;
      actions.hidden = !ok;
      added.classList.toggle('is-error', !ok);
      added.hidden = false;
      html.classList.add('has-added');
      place();
      requestAnimationFrame(place);
      live.textContent = '';
      live.textContent = `${heading}. ${body.innerText.replace(/\s+/g, ' ').trim()}`;
      schedule();
    };

    added.addEventListener('mouseenter', () => {
      hold = true;
      clearTimeout(timer);
    });
    added.addEventListener('mouseleave', () => {
      hold = added.contains(document.activeElement);
      if (!hold) schedule();
    });
    added.addEventListener('focusin', () => {
      hold = true;
      clearTimeout(timer);
    });
    added.addEventListener('focusout', (e) => {
      if (added.contains(e.relatedTarget)) return;
      hold = added.matches(':hover');
      if (!hold) schedule();
    });
    $$('[data-added-close]', added).forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !added.hidden && !document.querySelector('dialog[open]')) close();
    });
    // La barra de compra cambia de alto y se pega o se suelta al hacer scroll: se recalcula.
    let queued = false;
    const replace = () => {
      if (added.hidden || queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        place();
      });
    };
    addEventListener('resize', replace);
    addEventListener('scroll', replace, { passive: true });
    if ('ResizeObserver' in window) {
      const watcher = new ResizeObserver(replace);
      $$('.buybar').forEach((bar) => watcher.observe(bar));
    }

    return {
      show(cart, items, buy) {
        const lines = items
          .map((item) => ({ ...item, line: cart.items.find((l) => l.variant_id === item.id) }))
          .filter((item) => item.line);
        if (!lines.length) return;
        const first = lines[0].line;
        const model = cart.items.filter((l) => l.product_id === first.product_id);
        const modelPieces = model.reduce((sum, l) => sum + l.quantity, 0);
        const unit = first.final_price;
        const base = Number(buy?.dataset.price) || first.original_price;
        const tiers = buy ? $$('[data-tier-min]', buy).map((r) => ({ min: Number(r.dataset.tierMin), cents: Number(r.dataset.tierCents) })) : [];
        const active = tiers.findLast((t) => modelPieces >= t.min);
        // Solo es precio por volumen si el modelo tiene tabla; las ofertas del carrito llevan su propio descuento.
        const isVolume = tiers.length > 0 && (unit < first.original_price || (active && active.cents < base));
        const upcoming = tiers.find((t) => t.min > modelPieces && t.cents < unit);

        const flavors = lines
          .map(({ line, quantity }) => `<li>${esc(line.variant_title || line.product_title)} × ${quantity}</li>`)
          .join('');
        const groups = [];
        cart.items.forEach((l) => {
          const group = groups.find((g) => g.id === l.product_id);
          const saved = l.original_line_price - l.final_line_price;
          if (group) {
            group.qty += l.quantity;
            group.saved += saved;
          } else {
            groups.push({
              id: l.product_id,
              title: l.product_title,
              qty: l.quantity,
              image: l.image,
              handle: l.handle,
              original: l.original_price,
              final: l.final_price,
              saved,
            });
          }
        });
        // Precio por pieza tal como lo cobra Shopify: el normal tachado solo si hay descuento.
        const price = (original, final) =>
          final < original ? `<s>${money(original)}</s> <b>${money(final)}</b>` : `<b>${money(final)}</b>`;

        const content = `
          <div class="added__item">
            <span class="added__img">${thumb(first.image, first.handle, 160)}</span>
            <div>
              <p class="added__name">${esc(first.product_title)}</p>
              <ul class="added__flavors">${flavors}</ul>
              <p class="note added__price">${pieces(modelPieces)}: ${price(first.original_price, unit)} c/u${isVolume ? ', precio por volumen' : ''}</p>
              ${upcoming ? `<p class="note">Con ${upcoming.min - modelPieces} más baja a <b>${money(upcoming.cents)}</b></p>` : ''}
            </div>
          </div>
          <div class="added__cart">
            <p class="eyebrow muted">En tu carrito</p>
            <ul class="added__list">${groups
              .map(
                (g) =>
                  `<li><span class="added__thumb">${thumb(g.image, g.handle, 96)}</span><span class="added__line"><span class="added__line-name">${esc(g.title)}</span><span class="added__price">${price(g.original, g.final)} c/u${g.saved > 0 ? ` · Ahorras ${money(g.saved)}` : ''}</span></span><span>${pieces(g.qty)}</span></li>`,
              )
              .join('')}</ul>
            ${cart.total_discount > 0 ? `<p class="added__saved"><span>Ahorras</span><b>${money(cart.total_discount)}</b></p>` : ''}
            <p class="added__total"><span>Total: ${pieces(cart.item_count)}</span><span>Subtotal <b>${money(cart.total_price)}</b></span></p>
          </div>`;
        open('Agregado al carrito', content, true);
        // Envío gratis (versión corta) y productos con descuento: la misma sección que el carrito.
        fetch('/cart?section_id=cart-extras')
          .then((r) => (r.ok ? r.text() : ''))
          .then((markup) => {
            const box = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-extras]');
            if (!box || !box.children.length || added.hidden) return;
            body.querySelector('[data-cart-extras]')?.remove();
            body.append(box);
            place();
          })
          .catch(() => {});
      },
      error(message) {
        open('No se pudo agregar', `<p class="added__error">${esc(message)}</p><p class="note">Tus cantidades se quedaron como estaban.</p>`, false);
      },
    };
  })();

  /*
    Ficha y vista rápida: piezas por sabor, escalón de volumen, miniaturas por sabor y carrito.
    root es el contenedor con [data-product-root]; el bloque de compra es [data-product].
  */
  function initProduct(root, { onAdded } = {}) {
    const product = $('[data-product]', root);
    if (!product || product.dataset.ready) return;
    product.dataset.ready = 'true';

    const stage = $('[data-gallery-stage]', root);
    const mainImage = $('[data-gallery-main]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const showImage = (src, thumb) => {
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.removeAttribute('srcset');
      thumbs.forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showImage(t.dataset.src, t)));

    /* Miniaturas por sabor: el cursor solo cambia el color de fondo; elegir cambia la foto si el sabor tiene la suya */
    const flavors = $$('[data-flavor]', product);
    let color = product.dataset.color;
    const paint = (value) => stage?.style.setProperty('--flavor', value);
    const pick = (button) => {
      flavors.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
      color = button.dataset.color;
      paint(color);
      const src = button.dataset.src || product.dataset.featuredSrc;
      const thumb = thumbs.find((t) => t.dataset.src === src);
      showImage(src, thumb);
    };
    paint(color);
    flavors.forEach((button) => {
      button.addEventListener('click', () => pick(button));
      button.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') paint(button.dataset.color);
      });
      button.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') paint(color);
      });
    });

    const buttons = $$('[data-buy]', product);
    const inputs = $$('[data-qty]', product);
    const tiers = $$('[data-tier-min]', product).map((row) => ({
      row,
      min: Number(row.dataset.tierMin),
      cents: Number(row.dataset.tierCents),
    }));
    const basePrice = Number(product.dataset.price);
    const productId = Number(product.dataset.productId);
    let inCart = Number(product.dataset.inCart) || 0;
    const detail = $('[data-buy-detail]', product);
    const total = $('[data-buy-total]', product);
    const next = $('[data-buy-next]', product);
    const status = $('[data-buy-status]', product);

    const clamp = (input) => {
      const max = input.max === '' ? Infinity : Number(input.max);
      const value = Math.min(max, Math.max(0, Math.floor(Number(input.value)) || 0));
      input.value = value;
      return value;
    };

    const render = () => {
      if (!inputs.length) return;
      const selected = inputs.reduce((sum, input) => sum + clamp(input), 0);
      const count = selected + inCart;
      const active = tiers.findLast((t) => count >= t.min);
      const unit = active ? active.cents : basePrice;
      tiers.forEach((t) => t.row.classList.toggle('is-active', t === active && count > 0));

      buttons.forEach((b) => (b.disabled = selected === 0));
      total.textContent = money(selected * unit);
      detail.textContent = selected ? `${pieces(selected)} × ${money(unit)}` : 'Elige cuántas piezas de cada sabor';

      const upcoming = tiers.find((t) => t.min > count && t.cents < unit);
      next.hidden = !(upcoming && selected);
      if (upcoming && selected) {
        const missing = upcoming.min - count;
        next.innerHTML = `Con ${pieces(missing)} más, cada una baja a <b>${money(upcoming.cents)}</b>.`;
      }
    };

    $$('.qty', product).forEach((box) => {
      const input = $('[data-qty]', box);
      const step = (delta) => {
        input.value = Number(input.value) + delta;
        render();
        if (delta > 0) {
          const flavor = $('[data-flavor]', box.closest('.flavor'));
          if (flavor) pick(flavor);
        }
      };
      $('[data-qty-minus]', box).addEventListener('click', () => step(-1));
      $('[data-qty-plus]', box).addEventListener('click', () => step(1));
      input.addEventListener('change', render);
    });

    buttons.forEach((buy) =>
      buy.addEventListener('click', async () => {
        const items = inputs
          .map((input) => ({ id: Number(input.dataset.variantId), quantity: clamp(input) }))
          .filter((item) => item.quantity > 0);
        if (!items.length) return;

        buttons.forEach((b) => (b.disabled = true));
        status.classList.remove('is-error');
        status.textContent = 'Agregando…';
        try {
          let res;
          try {
            res = await fetch(`${window.theme.routes.cartAdd}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items }),
            });
          } catch {
            throw new Error('Sin conexión. Revisa tu internet e inténtalo de nuevo.');
          }
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');

          const addedCount = items.reduce((sum, item) => sum + item.quantity, 0);
          inputs.forEach((input) => (input.value = 0));
          status.innerHTML = `Agregaste ${pieces(addedCount)}. <a href="${window.theme.routes.cart}" style="text-decoration: underline">Ver carrito</a>`;

          if (buy.hasAttribute('data-buy-checkout')) {
            location.href = '/checkout';
            return;
          }

          let cart = null;
          try {
            cart = await getCart();
          } catch {
            // Si /cart.js falla, el producto ya se agregó: solo se suma en el contador.
          }
          if (cart) {
            setCartCount(cart.item_count);
            inCart = cart.items.filter((l) => l.product_id === productId).reduce((sum, l) => sum + l.quantity, 0);
          } else {
            inCart += addedCount;
            const el = $('[data-cart-count]');
            if (el) setCartCount(Number(el.textContent || 0) + addedCount);
          }
          render();
          onAdded?.();
          if (cart) addedNotice.show(cart, items, product);
        } catch (error) {
          status.classList.add('is-error');
          status.textContent = error.message;
          addedNotice.error(error.message);
        }
        render();
      }),
    );

    render();
  }

  $$('[data-product-root]').forEach((root) => initProduct(root));

  /* Vista rápida del Home: carga la sección quick-view del producto y usa el mismo bloque de compra */
  const qv = $('[data-qv]');
  if (qv && typeof qv.showModal === 'function') {
    const body = $('[data-qv-body]', qv);
    let opener = null;
    const close = () => qv.close();
    qv.addEventListener('close', () => {
      body.innerHTML = '';
      html.classList.remove('is-locked');
      opener?.focus();
    });
    qv.addEventListener('click', (e) => {
      if (e.target === qv) close();
    });
    $('[data-qv-close]', qv).addEventListener('click', close);

    document.addEventListener('click', async (e) => {
      const button = e.target.closest('[data-quick-view]');
      if (!button) return;
      e.preventDefault();
      opener = button;
      body.innerHTML = '<p class="qv__loading muted">Cargando…</p>';
      qv.showModal();
      html.classList.add('is-locked');
      try {
        const url = new URL(button.dataset.quickView, location.origin);
        url.searchParams.set('section_id', 'quick-view');
        const res = await fetch(url);
        if (!res.ok) throw new Error();
        body.innerHTML = await res.text();
        const root = $('[data-product-root]', body);
        if (!root) throw new Error();
        initProduct(root, { onAdded: close });
        showNotify(root);
      } catch {
        body.innerHTML = `<p class="qv__loading">No se pudo cargar el producto. <a href="${esc(button.dataset.quickView)}" style="text-decoration: underline">Ver ficha completa</a></p>`;
      }
    });
  }

  /*
    Carruseles automáticos (promociones y precios por modelo): dedo, flechas y puntos. Avanzan solos
    cada data-speed segundos (6 por defecto) salvo con el cursor, el dedo o el foco dentro, con el
    botón de pausa o si el visitante pidió reducir el movimiento.
  */
  $$('[data-carousel]').forEach((root) => {
    const track = $('[data-carousel-track]', root);
    const slides = $$('[data-slide]', root);
    if (!track || slides.length < 2) return;
    const dots = $$('[data-carousel-dot]', root);
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let hover = false;
    let focus = false;
    let touch = false;
    let paused = false;
    const speed = (Number(root.dataset.speed) || 6) * 1000;

    const mark = (i) => {
      index = i;
      dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
    };
    const go = (i) => {
      const target = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[target].offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
      mark(target);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) mark(slides.indexOf(entry.target));
        });
      },
      { root: track, threshold: 0.6 },
    );
    slides.forEach((s) => observer.observe(s));

    $('[data-carousel-prev]', root)?.addEventListener('click', () => go(index - 1));
    $('[data-carousel-next]', root)?.addEventListener('click', () => go(index + 1));
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));

    root.addEventListener('mouseenter', () => (hover = true));
    root.addEventListener('mouseleave', () => (hover = false));
    // El foco en el botón de pausa no cuenta: si no, "Reanudar" no reanudaría.
    root.addEventListener('focusin', (e) => (focus = !e.target.closest('[data-carousel-pause]')));
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) focus = false;
    });
    root.addEventListener('touchstart', () => (touch = true), { passive: true });
    root.addEventListener('touchend', () => setTimeout(() => (touch = false), speed), { passive: true });
    const pause = $('[data-carousel-pause]', root);
    pause?.addEventListener('click', () => {
      paused = !paused;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Reanudar el carrusel' : 'Pausar el carrusel');
      pause.classList.toggle('is-paused', paused);
    });
    setInterval(() => {
      if (hover || focus || touch || paused || reduce.matches || document.hidden) return;
      go(index + 1);
    }, speed);
    mark(0);
  });
  /*
    Carrusel horizontal (catálogo y precios del Home): dedo, trackpad, flechas y teclado.
    No avanza solo. Las flechas se ocultan en el extremo donde ya no hay más.
  */
  $$('[data-scroller]').forEach((root) => {
    const track = $('[data-scroller-track]', root);
    const prev = $('[data-scroller-prev]', root);
    const next = $('[data-scroller-next]', root);
    if (!track) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const itemWidth = () => {
      const item = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    };
    const move = (direction) => {
      const step = itemWidth();
      const visible = Math.max(1, Math.floor((track.clientWidth + 1) / step));
      track.scrollBy({ left: direction * visible * step, behavior: reduce.matches ? 'auto' : 'smooth' });
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    };
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('keydown', (e) => {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        move(e.key === 'ArrowRight' ? 1 : -1);
      }
    });
    track.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  });

  /*
    Precios por modelo: al pasar el cursor, tocar o pulsar Enter en una tarjeta se abre debajo
    el panel con su tabla. Cierra al salir con el cursor, al tocar otra vez o con Esc. Uno a la vez.
  */
  $$('[data-prices]').forEach((root) => {
    const panel = $('[data-price-panel]', root);
    const cards = $$('[data-price-card]', root);
    let current = null;
    let timer = null;
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    const open = (card) => {
      clearTimeout(timer);
      if (current === card) return;
      current?.setAttribute('aria-expanded', 'false');
      current = card;
      card.setAttribute('aria-expanded', 'true');
      panel.replaceChildren($('[data-price-content]', card.parentElement).content.cloneNode(true));
      panel.hidden = false;
    };
    const close = () => {
      clearTimeout(timer);
      current?.setAttribute('aria-expanded', 'false');
      current = null;
      panel.hidden = true;
    };
    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        if (fine.matches) open(card);
      });
      card.addEventListener('click', () => {
        // Con cursor el panel ya abrió al pasar por encima; el clic no lo cierra. Al tocar, alterna.
        if (current === card && !fine.matches) close();
        else open(card);
      });
    });
    root.addEventListener('mouseleave', () => {
      if (fine.matches) timer = setTimeout(close, 200);
    });
    root.addEventListener('mouseenter', () => clearTimeout(timer));
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && current) {
        const card = current;
        close();
        card.focus();
      }
    });
  });
  /*
    Avisos de regreso al inventario (STOQ): cada sabor agotado lleva "Avísame", que abre el
    formulario de la app con ese sabor elegido. Los botones solo se muestran si la app está
    encendida en el tema; si no, no se ve nada y no hay errores.
  */
  const showNotify = (root = document) => {
    if (!window._RestockRocket) return;
    $$('[data-notify]', root).forEach((b) => (b.hidden = false));
  };
  addEventListener('load', () => showNotify());
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-notify]');
    if (!button || !window._RestockRocket) return;
    const data = button.closest('[data-product]')?.querySelector('[data-product-json]');
    if (!data) return;
    try {
      window._RestockRocket.openModal(JSON.parse(data.textContent), String(button.dataset.variantId));
    } catch {
      // Si la app no responde, el sabor sigue marcado como agotado.
    }
  });
  /* Productos con descuento del carrito: "Agregar" suma una pieza del sabor elegido */
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-offer-add]');
    if (!button) return;
    const offer = button.closest('[data-offer]');
    const id = Number($('[data-offer-variant]', offer)?.value);
    if (!id) return;
    button.disabled = true;
    const label = button.textContent;
    button.textContent = 'Agregando…';
    try {
      const res = await fetch(`${window.theme.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar al carrito.');
      if (document.body.classList.contains('template-cart')) {
        location.reload();
        return;
      }
      const cart = await getCart();
      setCartCount(cart.item_count);
      addedNotice.show(cart, [{ id, quantity: 1 }], null);
    } catch (error) {
      addedNotice.error(error.message === 'Failed to fetch' ? 'Sin conexión. Revisa tu internet e inténtalo de nuevo.' : error.message);
      button.disabled = false;
      button.textContent = label;
    }
  });
})();
